import { render } from "./StyleSelector.vue?vue&type=template&id=458b3032&scoped=true"
import script from "./StyleSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./StyleSelector.vue?vue&type=script&setup=true&lang=js"

import "./StyleSelector.vue?vue&type=style&index=0&id=458b3032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458b3032"],['__file',"src/config-app/components/StyleSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "458b3032"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('458b3032', __exports__)) {
    api.reload('458b3032', __exports__)
  }
  
  module.hot.accept("./StyleSelector.vue?vue&type=template&id=458b3032&scoped=true", () => {
    api.rerender('458b3032', render)
  })

}


export default __exports__